import { Stack, IconButton, InputAdornment, InputBase } from '@mui/material'
import { KeyboardArrowDownRounded, KeyboardArrowUpRounded } from '@mui/icons-material'

function PointsAdjust({
  points = 10,
  setPoints = () => {},
  onChange = () => {},
  sx = {},
  endAdornment = null,
  min = 1,
  max = 999,
  customWidth = '',
}) {
  const incrementScore = e => {
    e.preventDefault()
    e.stopPropagation()
    const numericPoints = Number(points) // Ensure points is treated as a number

    if (numericPoints < max) {
      onChange(numericPoints + 1)
      setPoints(numericPoints + 1)
    }
  }

  const decrementScore = e => {
    e.preventDefault()
    e.stopPropagation()
    const numericPoints = Number(points) // Ensure points is treated as a number

    if (numericPoints > min) {
      onChange(numericPoints - 1)
      setPoints(numericPoints - 1)
    }
  }

  const handleKeyDown = event => {
    if (event.key === 'ArrowUp') {
      incrementScore()
    } else if (event.key === 'ArrowDown') {
      decrementScore()
    }
  }

  return (
    <Stack flexDirection="row" gap="4px">
      <InputBase
        color="primary"
        endAdornment={
          endAdornment ? (
            <InputAdornment
              position="end"
              sx={{ maxWidth: '20px', '& .MuiTypography-root': { fontSize: '14px', fontWeight: 500 } }}
            >
              {endAdornment}
            </InputAdornment>
          ) : null
        }
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
          maxLength: 3,
          min: min,
          max: max,
          'aria-label': 'Score Input',
        }}
        size="small"
        sx={{
          height: '40px',
          borderRadius: '10px',
          border: '1px solid #D0D5DD',
          padding: '12px',
          bgcolor: 'white',
          fontSize: '14px',
          fontWeight: 500,
          color: '#344054',
          width: 'fit-content',
          '& .MuiInputBase-input': {
            padding: 0,
            width: customWidth || undefined,
          },
          ...sx,
        }}
        value={points}
        onChange={e => {
          const value = e.target.value
          let number = value === '' ? 0 : Number(value)

          if (number < min || !number) {
            number = min
          }
          if (number > max) {
            number = max
          }
          onChange(number)
          setPoints(number)
        }}
        onKeyDown={handleKeyDown}
      />
      <Stack gap="2px">
        <IconButton
          aria-label="Increment"
          sx={{
            height: '19px',
            width: '19px',
            border: '1px solid #D0D5DD',
            borderRadius: '3px',
            bgcolor: 'white',
            '&:hover': {
              bgcolor: '#F4F5F7',
            },
          }}
          onClick={incrementScore}
        >
          <KeyboardArrowUpRounded
            color="secondary"
            style={{
              width: '17px',
              height: '17px',
            }}
          />
        </IconButton>
        <IconButton
          aria-label="Decrement"
          sx={{
            height: '19px',
            width: '19px',
            border: '1px solid #D0D5DD',
            borderRadius: '3px',
            bgcolor: 'white',
            '&:hover': {
              bgcolor: '#F4F5F7',
            },
          }}
          onClick={decrementScore}
        >
          <KeyboardArrowDownRounded
            color="secondary"
            style={{
              width: '17px',
              height: '17px',
            }}
          />
        </IconButton>
      </Stack>
    </Stack>
  )
}

export default PointsAdjust
